export default {
  URL: "/brf/brf_quota_handling/",
  URL_PAYMENT_GROUP: "/brf/brf_payment_quota_handling/",

  STORE_NAME: "brfQuotaHandling",
};
